import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useIsSquadEnabled = () => {
  const { sport } = useSportContext();
  const {
    flags: { enableSquadsForSports = [] },
  } = useFeatureFlags();

  if (!Array.isArray(enableSquadsForSports)) {
    return false;
  }

  return enableSquadsForSports.includes(sport.toLowerCase());
};
